module.exports = __webpack_public_path__ + "img/Logo_300.35ccec99.svg";